module.exports = __webpack_public_path__ + "static/img/Video.e8cbc74.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/miximo/imgs/browse/Video.jpg
// module id = 1763
// module chunks = 0